var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "256px",
    viewBox: "0 0 256 256",
    width: "256px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Classic",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tether",
    transform: "translate(-5223.000000, -1122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5223.000000, 1122.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128,0 C198.68928,0 256,57.31072 256,128 C256,198.68928 198.68672,256 128,256 C57.31328,256 0,198.70464 0,128 C0,57.29536 57.30304,0 128,0",
    fill: "#53AE94",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.808,139.8323 L143.808,139.817042 C142.91968,139.87326 138.3552,140.14718 128.192,140.14718 C120.06656,140.14718 114.35008,139.91678 112.33536,139.81182 L112.33536,139.83742 C81.06752,138.45246 57.728,133.007442 57.728,126.492242 C57.728,119.977042 81.07008,114.5395 112.33536,113.15198 L112.33536,134.41278 C114.38336,134.55358 120.24064,134.89918 128.32512,134.89918 C138.0352,134.89918 142.91712,134.4947 143.81312,134.41278 L143.81312,113.15198 C175.01952,114.54206 198.30528,119.9923 198.30528,126.48446 C198.30528,132.97662 175.00928,138.42942 143.81312,139.8195 M143.79776,110.94526 L143.79776,91.9039795 L187.3408,91.9039795 L187.3408,62.8914995 L68.77184,62.8914995 L68.77184,91.9039795 L112.32,91.9039795 L112.32,110.9299 C76.928,112.5555 50.3168,119.56478 50.3168,127.96158 C50.3168,136.35838 76.9408,143.36766 112.32,145.0035 L112.32,205.9955 L143.808,205.9955 L143.808,144.99838 C179.136,143.36766 205.69344,136.3635 205.69344,127.97438 C205.69344,119.58526 179.136,112.5811 143.808,110.95038",
    fill: "#FFFFFF",
    id: "Fill-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.1b7e5257ed50c0ceb6ac3d4667bd0cbd.svg";
export { ForwardRef as ReactComponent };